<template>
  <div>
    <zp-modal-youtube v-model="modalYouTube" :video="video"></zp-modal-youtube>
    <div v-if="loading" style="height: 100%;" class="d-flex flex-column justify-center align-center">
      <v-progress-circular
        :width="3"
        :size="60"
        color="blue"
        indeterminate
      ></v-progress-circular>
      <strong class="mt-5">Carregando os vídeos...</strong>
    </div>
    <template v-else>
      <div v-for="(item, index) in items" :key="index" :class="index ? 'mt-5' : ''">
        <h2>{{item.name}}</h2>
        <div class="d-flex flex-wrap">
          <div v-for="(item) in item.videos" :key="item.id">
            <v-card class="ma-3 ml-0" style="position: relative;" outlined max-width="344">
              <v-img :src="item.thumbnail" height="200px"></v-img>

              <v-chip v-if="item.privacy_status === 'Premium'" label small color="amber" style="position: absolute; top: 10px; right: 10px;">Conteúdo premium</v-chip>

              <v-card-title style="word-break: break-word;">
                {{item.title}}
              </v-card-title>

              <v-card-subtitle>
                {{item.created_at | datetime}}
              </v-card-subtitle>

              <v-card-actions>
                <v-btn color="blue" text v-if="item.privacy_status !== 'Premium' || isActivePlan" @click="openVideo(item)">
                  Assistir agora
                </v-btn>
                <v-btn color="green" depressed dark v-else @click="$router.push('/plano')">
                  Adquirir o plano
                </v-btn>

                <v-spacer></v-spacer>

                <v-btn icon @click="toggleDescription(item.id)"  v-if="item.description">
                  <v-icon>{{ showDescription[item.id] ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
              </v-card-actions>

              <v-expand-transition v-if="item.description">
                <div v-show="showDescription[item.id]">
                  <v-divider></v-divider>
                  <v-card-text style="white-space: pre-line;">{{item.description}}</v-card-text>
                </div>
              </v-expand-transition>
            </v-card>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import ZpModalYoutube from '@/components/ModalYoutube'

export default {
  components: {
    ZpModalYoutube
  },
  data () {
    return {
      loading: false,
      modalYouTube: false,
      video: {},
      showDescription: {}
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      videos: state => state.videos.data
    }),
    isActivePlan () {
      return moment(this.user.active_plan_at || 0).valueOf() > Date.now()
    },
    items () {
      const data = Object.values(this.videos.reduce((data, item) => {
        data[item.section] = data[item.section] || { name: item.section, videos: [] }
        data[item.section].videos.push(item)
        return data
      }, {}))

      data.sort((a, b) => a.name.localeCompare(b.name))

      return data
    }
  },
  async mounted () {
    this.loading = true
    const videos = await this.$store.dispatch('videos/index')

    if (this.$route.query.v) {
      this.openVideo(videos.find(item => item.video_id === this.$route.query.v))
    }

    this.loading = false
  },
  methods: {
    toggleDescription (id) {
      this.showDescription = {
        ...this.showDescription,
        [id]: !this.showDescription[id]
      }
    },
    openVideo (video) {
      if (video) {
        this.video = video
        this.modalYouTube = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>